import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment';
import Field from '../../Field';
import TextInput from '../../TextInput';
import DateInput from '../../DateInput';
import CheckboxInput from '../../CheckboxInput';
import GenderInput from '../../GenderInput';
import GroupInput from '../../GroupInput';
import PhoneInput from '../../PhoneInput';
import {validators, validate} from '../../../validation';
import './ContactForm.less';


export default class ContactForm extends PureComponent {
  static propTypes = {
    setFirstName: PropTypes.func,
    setLastName: PropTypes.func,
    setEmailAddress: PropTypes.func,
    setMobilePhone: PropTypes.func,
    setDateOfBirth: PropTypes.func,
    setGender: PropTypes.func,
    setMaritalStatus: PropTypes.func,
    First_Name: PropTypes.string,
    Last_Name: PropTypes.string,
    Email_Address: PropTypes.string,
    Mobile_Phone: PropTypes.string,
    Date_of_Birth: PropTypes.string,
    Group_ID: PropTypes.number,
    Gender_ID: PropTypes.number,
    Marital_Status_ID: PropTypes.number,

    setFirstNameErrors: PropTypes.func,
    setLastNameErrors: PropTypes.func,
    setEmailAddressErrors: PropTypes.func,
    setMobilePhoneErrors: PropTypes.func,
    setDateOfBirthErrors: PropTypes.func,
    setGroupErrors: PropTypes.func,
    setGenderErrors: PropTypes.func,
    setMaritalStatusErrors: PropTypes.func,
    First_Name_Errors: PropTypes.arrayOf(PropTypes.string),
    Last_Name_Errors: PropTypes.arrayOf(PropTypes.string),
    Email_Address_Errors: PropTypes.arrayOf(PropTypes.string),
    Mobile_Phone_Errors: PropTypes.arrayOf(PropTypes.string),
    Date_of_Birth_Errors: PropTypes.arrayOf(PropTypes.string),
    Group_ID_Errors: PropTypes.arrayOf(PropTypes.string),
    Gender_ID_Errors: PropTypes.arrayOf(PropTypes.string),
    Marital_Status_ID_Errors: PropTypes.arrayOf(PropTypes.string),

    hideMaritalStatus: PropTypes.bool,
    hideGender: PropTypes.bool,
    hideDateOfBirth: PropTypes.bool,
    className: PropTypes.string,
    title: PropTypes.string
  };

  render() {
    let {
      First_Name,
      Last_Name,
      Email_Address,
      Mobile_Phone,
      Date_of_Birth,
      Group_ID,
      Gender_ID,
      Marital_Status_ID,
      Guest,
      setFirstName,
      setLastName,
      setEmailAddress,
      setMobilePhone,
      setDateOfBirth,
      setGroup,
      setGender,
      setGuest,
      setMaritalStatus,

      First_Name_Errors,
      Last_Name_Errors,
      Email_Address_Errors,
      Mobile_Phone_Errors,
      Date_of_Birth_Errors,
      Group_ID_Errors,
      Gender_ID_Errors,
      Marital_Status_ID_Errors,
      Guest_Errors,
      setFirstNameErrors,
      setLastNameErrors,
      setEmailAddressErrors,
      setMobilePhoneErrors,
      setDateOfBirthErrors,
      setGroupErrors,
      setGenderErrors,
      setGuestErrors,
      setMaritalStatusErrors,

      First_Name_Label = 'First Name...',
      Last_Name_Label = 'Last Name...',
      Mobile_Phone_Label = 'Phone...',
      Email_Address_Label = 'Email...',
      Gender_Label = 'Gender',
      Date_of_Birth_Label = 'D.O.B....',

      hideMaritalStatus = false,
      hideGender = false,
      hideEmailAddress = false,
      hideMobilePhone = false,
      hideDateOfBirth = false,
      className,
      title,
      showGuest = false
    } = this.props;

    const eighteenYearsAgo = moment().subtract(18, 'years');

    return (
      <div className={cx("contact-form", className)}>
        <Field label={First_Name_Label} value={First_Name} onChange={setFirstName}
            validators={[validators.required()]}
            errors={First_Name_Errors}
            setErrors={setFirstNameErrors}>
          <TextInput />
        </Field>
        <Field label={Last_Name_Label} value={Last_Name} onChange={setLastName}
            validators={[validators.required()]}
            errors={Last_Name_Errors}
            setErrors={setLastNameErrors}>
          <TextInput />
        </Field>
        {!hideMobilePhone && <Field label={Mobile_Phone_Label} value={Mobile_Phone} onChange={setMobilePhone}
            validators={[validators.required(), validators.phone()]}
            errors={Mobile_Phone_Errors}
            setErrors={setMobilePhoneErrors}>
          <PhoneInput />
          {/*<TextInput type="tel" />*/}
        </Field>}
        {!hideEmailAddress && <Field label={Email_Address_Label} value={Email_Address} onChange={setEmailAddress}
            validators={[validators.required(), validators.email()]}
            errors={Email_Address_Errors}
            setErrors={setEmailAddressErrors}>
          <TextInput type="email" />
        </Field>}
        {!hideGender && <Field label={Gender_Label} value={Gender_ID} onChange={setGender}
            validators={[validators.required()]}
            errors={Gender_ID_Errors}
            setErrors={setGenderErrors}>
          <GenderInput />
        </Field>}
        {!hideDateOfBirth && <Field label={Date_of_Birth_Label} value={Date_of_Birth && moment(Date_of_Birth)} onChange={setDateOfBirth}
            validators={[validators.required(), validators.momentObject()]}
            errors={Date_of_Birth_Errors}
            setErrors={setDateOfBirthErrors}>
          <DateInput />
        </Field>}
        {(!hideDateOfBirth && Date_of_Birth && moment(Date_of_Birth).isAfter(eighteenYearsAgo)) &&
          <Field label="Grade" value={Group_ID} onChange={setGroup}
              errors={Group_ID_Errors}
              setErrors={setGroupErrors}>
            <GroupInput />
          </Field>
        }
        {!hideMaritalStatus && <Field stacked
            label="Would you like to add info for your spouse?"
            showLabel
            value={Marital_Status_ID === 2}
            onChange={value => setMaritalStatus(value ? 2 : null)}
            errors={Marital_Status_ID_Errors}
            setErrors={setMaritalStatusErrors}>
          <CheckboxInput>Yes</CheckboxInput>
        </Field>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/form-route/forms/ContactForm.js